module.exports = __webpack_public_path__ + "static/editor_screen@3x-aedccb35501910a8d645f8a595d90d34.png";